import { Container } from "./styles";
import {
  descriptionByIndicationStatus,
  translateIndicationsStatus,
} from "~/utils";
import { EIndicationStatus } from "~/graphql/types";
import { Tooltip } from "@mui/material";
import { ReactNode } from "react";

type IndicationsStatusProps = {
  status: EIndicationStatus;
  errorMessage?: string;
  onlyCanceledTooltip?: boolean;
};

export const IndicationsStatus: React.FC<IndicationsStatusProps> = ({
  status,
  errorMessage,
  onlyCanceledTooltip = false,
}) => {
  const isCanceled = status === EIndicationStatus.canceled;
  const tooltipText = isCanceled
    ? errorMessage
    : descriptionByIndicationStatus(status);
  const shouldShowTooltip = onlyCanceledTooltip
    ? isCanceled
    : Boolean(tooltipText);

  const content: ReactNode = (
    <Container status={status || EIndicationStatus.pending}>
      <span>{translateIndicationsStatus(status)}</span>
    </Container>
  );

  if (!shouldShowTooltip) {
    return content;
  }

  return <Tooltip title={tooltipText}>{content}</Tooltip>;
};
